var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"light-container"},[_c('div',{staticClass:"power-areas"},[_c('CommonTree')],1),_c('div',{staticClass:"map-content"},[_c('MapIndex')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }